module.exports = __webpack_public_path__ + "img/case-lg-3.bead3e0e.jpg";